export default __webpack_public_path__ + "static/media/whitepaperfour.02f6946a.png";